import React, { useEffect } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

const colors = ['#9b061b', '#1e314b', '#e7b94d', '#208064'];

const pieces = Array.from({ length: 28 }, (_, index) => ({
  id: index,
  left: `${(index * 37) % 96}%`,
  delay: (index % 8) * 0.05,
  color: colors[index % colors.length],
  rotate: (index * 47) % 180
}));

function Celebration({ celebration, onClose }) {
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    if (!celebration) return undefined;

    const timer = window.setTimeout(onClose, 2000);
    return () => window.clearTimeout(timer);
  }, [celebration?.instance, onClose]);

  const handleBackdropClick = () => {
    onClose();
  };

  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <AnimatePresence>
      {celebration && (
        <div
          className="celebration"
          role="presentation"
          aria-live="polite"
          onClick={handleBackdropClick}
        >
          {!reducedMotion && pieces.map((piece) => (
            <motion.span
              className="confetti"
              key={`${celebration.instance}-${piece.id}`}
              style={{
                left: piece.left,
                background: piece.color
              }}
              initial={{ y: -30, opacity: 0, rotate: 0 }}
              animate={{
                y: '100vh',
                opacity: [0, 1, 1, 0],
                rotate: piece.rotate + 300
              }}
              transition={{
                duration: 1.7,
                delay: piece.delay,
                ease: 'easeIn'
              }}
            />
          ))}

          <motion.div
            className="celebration-message"
            role="dialog"
            aria-modal="true"
            aria-label={celebration.title}
            onClick={stopPropagation}
            initial={{
              opacity: 0,
              scale: reducedMotion ? 1 : 0.8,
              y: 8
            }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0
            }}
            exit={{ opacity: 0 }}
          >
            <span aria-hidden="true">✨</span>
            <strong>{celebration.title}</strong>
            <p>{celebration.text}</p>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

export default Celebration;